import { Component, OnInit, OnDestroy, Input, ViewChild, ViewContainerRef, ComponentRef } from '@angular/core';

@Component({
  selector: 'app-question-subsection',
  templateUrl: './subsection.component.html'
})
export class SubsectionComponent implements OnInit, OnDestroy {
  @ViewChild("subsectionContainer", { read: ViewContainerRef }) subsectionContainer: ViewContainerRef;
  @Input() prompt:string;
  @Input() disabled:boolean;

  children:ComponentRef<any>[];

  constructor(){
    this.children = [];
  }

  isValid():boolean {
    if(!this.disabled) {
      for(let i in this.children){
        try {
          if(!this.children[i].instance.isValid()) {
            return false;
          }
        } catch(err) {
          console.log('child error',this.children[i].instance.prompt,err);
          return false;
        }
      }
    }
    return true;
  }
  validate():boolean {
    var result:boolean=true;
    if(!this.disabled) {
      for(let i in this.children){
        try {
          if(!this.children[i].instance.validate()) {
            console.log('validation failed',this.children[i].instance.prompt);
            result=false;
          }
        } catch(err) {
          console.log('child error',this.children[i].instance.prompt,err);
          result=false;
        }
      }
    }
    return result;
  }

  public getValue():object {
    var result={};
    for(let i in this.children){
      Object.assign(result,this.children[i].instance.getValue());
    }
    if(!!this.disabled) {
      for(let i in result) {
        result[i]=null;
      }
    }
    return result;
  }

  addChild(factory,itemdata){
    var componentRef:ComponentRef<any>=this.subsectionContainer.createComponent(factory);
    this.children.push(componentRef);
    for(let i in itemdata) {
      componentRef.instance[i]=itemdata[i];
    }
    return componentRef.instance;
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    var C;
    while(C=this.children.pop()) {
      C.destroy();
    }
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/subsection.component.ts